import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Kính mắt Nhân Văn - Kính Mắt Chất Lượng Cao',
  description = 'Khám phá kính mát và kính cận cao cấp tại Kính mắt Nhân Văn. Mua sắm bộ sưu tập kính thời trang chất lượng với bảo vệ UV và lọc ánh sáng xanh.',
  keywords = 'kính mát, kính cận, kính mắt, kính chống ánh sáng xanh, kính thời trang, mua kính online',
  ogImage = 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=1200',
  ogType = 'website',
  canonicalUrl
}) => {
  const siteUrl = window.location.origin;
  const currentUrl = canonicalUrl || window.location.href;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Kính mắt Nhân Văn" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Kính mắt Nhân Văn" />

      {/* Viewport and Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#dc2626" />
    </Helmet>
  );
};

export default SEO;
